import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'
import ToolDetail from '../views/ToolDetail.vue'
import GeneFamilyTool from '../views/GeneFamilyTool.vue'
import AddTool from '../views/AddTool.vue'
import HistoryTasks from '../views/HistoryTasks.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/main'
  },
  {
    path: '/main',
    name: 'Main',
    component: Main
  },
  {
    path: '/tool/:id',
    name: 'ToolDetail',
    component: ToolDetail,
    props: true
  },
  {
    path: '/tool/gene-family/:id',
    name: 'GeneFamilyTool',
    component: GeneFamilyTool,
    props: true
  },
  {
    path: '/add-tool',
    name: 'AddTool',
    component: AddTool
  },
  {
    path: '/edit-tool/:id',
    name: 'EditTool',
    component: AddTool,
    props: true
  },
  {
    path: '/history-tasks',
    name: 'HistoryTasks',
    component: HistoryTasks
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  // 需要登录才能访问的页面
  const authRequiredPaths = ['/history-tasks', '/add-tool', '/edit-tool']
  const needsAuth = authRequiredPaths.some(path => to.path.startsWith(path))
  if (needsAuth && !token) {
    // 未登录访问需要授权的页面，先放行到主页
    next('/main')
  } else {
    next()
  }
})

export default router
